import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/app-shell';
import { getEscopo, getToken } from '@/lib/session';

/** Layout protegido: sem JWT volta ao login; com senha temporaria so a tela de troca de senha abre. */
export const Route = createFileRoute('/_app')({
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/login' });
    if (getEscopo() === 'TROCA_SENHA') throw redirect({ to: '/trocar-senha' });
  },
  component: AppShell,
});
